import React from "react";

import useBook from "../../hooks/useBook";

import ArchiveCanvas from "../../shared_comp/ArchiveCanvas";
import SectionTitle from "../../shared_comp/SectionTitle";
import MainCanvas from "../../shared_comp/MainCanvas";

import { Box, Text, DataTable, Spinner } from "grommet";

const BiographyMain = () => {
    const [received, setReceived] = React.useState(false);
    const [booksBiography, setBooksBiography] = React.useState<any>([]);

    React.useEffect(() => {
        const receiveData = async () => {
            const res = await useBook.getBookList("biography");
            console.log("received books", res);
            setBooksBiography(res.books);
            setReceived(true);
        };
        receiveData();
    }, []);

    console.log("Biography", booksBiography);

    const BookTable = () => {
        let c = [
            ["authors",'저자'],
            ["book_title",'제목'],
            ["publisher",'출판사'],
            ["publish_year",'출판년도'],
            ["library",'소장처']
        ];
        const [cols, setCols] = React.useState<any>([]);
        let col_list: any = [];

        React.useEffect(() => {

            c.map((col) => {
                let check_primary = false
                let check_pin = false
                let check_size='100px'
                if (col[0] === "authors") {
                    check_primary = true
                    check_pin=true
                    check_size='70px'
                } else if (col[0] === "book_title") {
                    check_primary = true
                    check_size = '400px'
                } else if (col[0] === "publish_year") {
                    check_size='60px'
                }
                let a_col = {
                    property: col[0],
                    header: <Box align='center'><Text size='13px'>{col[1]}</Text></Box>,
                    primary:check_primary,
                    pin:check_pin,
                    sortable:true,
                    search:true,
                    size:check_size,
                    render: (datum: any) => <Box style={{minWidth:check_size}} align='start' pad={{vertical:'3px'}}><Text size='13px'>{datum[col[0]]}</Text></Box>
                }
                col_list.push(a_col)
            })
            setCols(col_list);
        }, []);
        const [sort, setSort] = React.useState<any>([
            {'authors':'asc'},
            {'book_title':'asc'},
            {'publish_year':'asc'}
        ]);
        return (
            <DataTable
            fill
                step={10}
                show={20}
                data={booksBiography}
                columns={cols}
                pin
                sort={sort}
                onSort={setSort}
                resizeable
                background={{header:{color:'white'}, pinned:{color:'rgba(255,255,255,0.8)'}}}
                border={{body:{color:'grey', size:'0.1px', side:'bottom'}}}
            />
        );
    };

    return (
        <ArchiveCanvas>
            <SectionTitle title="참고자료 / 회고록" />
            <MainCanvas>
                {received ? (
                    <Box width='full' pad="10px" height='full' flex={false} overflow={'scroll'}
                    background='rgba(255,255,255,0.8)' align='start' justify='start'>
                        <BookTable />
                    </Box>
                ) : (
                    <Spinner />
                )}
            </MainCanvas>
        </ArchiveCanvas>
    );
};
export default BiographyMain;
